import React from "react";
import {
  useShow,
  IResourceComponentsProps,
} from "@refinedev/core";
import {
  Show,
  NumberField,
  DateField,
  BooleanField,
  TextFieldComponent as TextField,
} from "@refinedev/mui";
import {
  Typography,
  Stack,
  Box,
  Grid,
  Card,
  CardContent,
  Chip,
} from "@mui/material";
import { IPromocode } from "./PromocodeList";

export const PromocodeShow: React.FC<IResourceComponentsProps> = () => {
  const { queryResult } = useShow<IPromocode>();
  const { data, isLoading } = queryResult;
  const record = data?.data;

  return (
    <Show isLoading={isLoading}>
      <Grid container spacing={2}>
        <Grid item xs={12} lg={6}>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Promocode Details
              </Typography>

              <Stack direction="column" spacing={2}>
                <Box>
                  <Typography variant="body1" fontWeight="bold">
                    Code
                  </Typography>
                  <TextField value={record?.code} />
                </Box>

                <Box>
                  <Typography variant="body1" fontWeight="bold">
                    Duration
                  </Typography>
                  <NumberField value={record?.duration ?? 0} /> days
                </Box>

                <Box>
                  <Typography variant="body1" fontWeight="bold">
                    Max Uses
                  </Typography>
                  <NumberField value={record?.maxUses ?? 0} />
                </Box>

                <Box>
                  <Typography variant="body1" fontWeight="bold">
                    Used Count
                  </Typography>
                  <NumberField value={record?.usedCount ?? 0} />
                </Box>
              </Stack>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} lg={6}>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Status
              </Typography>

              <Stack direction="column" spacing={2}>
                <Box>
                  <Typography variant="body1" fontWeight="bold">
                    Expires At
                  </Typography>
                  <DateField value={record?.expiresAt} />
                </Box>

                <Box>
                  <Typography variant="body1" fontWeight="bold">
                    Active
                  </Typography>
                  <BooleanField value={record?.isActive} />
                </Box>

                <Box>
                  <Typography variant="body1" fontWeight="bold">
                    Status
                  </Typography>
                  {record?.isActive ? (
                    record?.usedCount < record?.maxUses ? (
                      <Chip label="Valid" color="success" />
                    ) : (
                      <Chip label="Fully Used" color="warning" />
                    )
                  ) : (
                    <Chip label="Inactive" color="error" />
                  )}
                </Box>
              </Stack>
            </CardContent>
          </Card>
        </Grid>

        {record?.usedBy && record?.usedBy.length > 0 && (
          <Grid item xs={12}>
            <Card>
              <CardContent>
                <Typography variant="h6" gutterBottom>
                  Used By
                </Typography>
                <Box sx={{ overflowX: "auto" }}>
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <thead>
                      <tr>
                        <th style={{ textAlign: "left", padding: "8px" }}>
                          User ID
                        </th>
                        <th style={{ textAlign: "left", padding: "8px" }}>
                          Email
                        </th>
                        <th style={{ textAlign: "left", padding: "8px" }}>
                          Date Used
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {record?.usedBy.map((user: any, index: number) => (
                        <tr key={index}>
                          <td style={{ padding: "8px" }}>{user.id}</td>
                          <td style={{ padding: "8px" }}>{user.email}</td>
                          <td style={{ padding: "8px" }}>
                            {new Date(user.dateUsed).toLocaleString()}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        )}
      </Grid>
    </Show>
  );
};
